//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import searchCityPicker from '@/components/mpvue-citypicker/searchCityPicker.vue'
import showMask from '@/components/mask/mask.vue'
import {
	getLIstByCodeSimple
} from '@/common/js/dictionary.js'
export default {
	props: {
		isFixed: { //是否固定顶部
			type: Boolean,
			default: false
		},
		placeholder: { //搜索栏提示信息
			type: String,
			default: '搜索'
		},
		color: { //搜索图标颜色
			type: String,
			default: '#afafaf'
		},
		areaShow: { //是否展示地区
			type: Boolean,
			default: false
		},
		cityName: { //地区展示的名称
			type: String,
			default: '地区'
		},
		actions: { //地区的列表
			type: Array,
			default () {
				return []
			}
		},
		menu: { //主筛选栏及子筛选栏
			// title:'' 主筛选栏标题,
			// detailList:[	子筛选栏数组
			// 	{
			// 		name:'' 展示名称
			// 		code:'' 对应的code
			// 	}
			// ]
			type: Array,
			default () {
				return []
			}
		},
		name: { //简单搜索时名称的搜索
			type: String,
			default: ''
		},
	},
	data() {
		return {
			index: 0, //value 的值表示选择了 range 中的第几个（下标从 0 开始）
			active: '', //选中的主标题
			titleList: [], //主筛选栏列表
			popList: [], //子筛选栏列表
			activeTag: '', //选中的标签
			area: false, //地区的选中
			popupShow: false, //是否展示子筛选栏
			height: 0,
			cityPickerValueDefault: [0, 0, 0],
			style: false,
			showCityBox:false
		}
	},
	components: {
		showMask,
		searchCityPicker
	},
	mounted() {
		let query = uni.createSelectorQuery().in(this)
		if (this.isFixed) {
			query.select('.isFixed').boundingClientRect(res => {
				this.height = res.height
			}).exec()
		} else {
			query.select('.searchContent').boundingClientRect(res => {
				this.height = res.height
			}).exec()
		}
	},
	methods: {
		//普通类型筛选
		//确定
		confirm(item) {
			this.activeTag = item.code?item.code:this.activeTag
			let object = {
				code: this.activeTag||item.code,
				index: this.active
			}
			this.$emit('confirm', object)
			this.popupShow = false
		},
		//重置
		reset() {
			this.$emit('reset', this.active)
			this.popupShow = false
			this.activeTag = ''
		},
		//主筛选栏标签选择
		tagChange(item, index) {
			if (this.active === index) {
				this.popupShow = !this.popupShow
			} else {
				this.style = item.style === 'columnar' ? true : false
				this.active = index
				this.popList = item.detailList
				this.activeTag = ''
				this.area = false
				this.popupShow = true
			}
		},
		//子筛选栏标签选择
		chooseTag(item, index) {
			this.activeTag = item.code
		},
		//地区类型筛选
		//地区筛选栏选中
		chooseCity() {
			this.cancel()
			this.active = ''
			this.popupShow = false
		},
		showCityPicker() {
			this.cancel()
			this.active = ''
			this.popupShow = false
			this.showCityBox = true
			this.$refs.searchCityPicker.show()
		},
		cancel() {
			this.area = !this.area
		},
		//地区筛选子筛选选中项
		changePicker(e) {
			this.cancel()
			this.$emit('changePicker', e)
		},
		//普通搜索相关
		nameInput(e) {
			this.$emit('nameInput', e)
		},
		focus(e) {
			this.$emit('focus')
		},
		search() {
			this.$emit('search')
		}
	}
}
